import { Box, Typography } from "@mui/material";
import { chartPalette } from "./ChartTheme";

export type BulletDatum = {
  label: string;
  actual: number;
  target: number;
};

type Props = {
  data: BulletDatum[];
};

export default function BulletChart({ data }: Props) {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
      {data.map((x) => {
        const max = Math.max(x.actual, x.target, 1);
        const actualPct = Math.min((x.actual / max) * 100, 100);
        const targetPct = Math.min((x.target / max) * 100, 100);

        return (
          <Box key={x.label}>
            <Typography variant="caption" sx={{ fontWeight: 700, color: chartPalette.navy }}>
              {x.label}
            </Typography>
            <Box sx={{ position: "relative", height: 18, bgcolor: chartPalette.lightGrey, borderRadius: 1 }}>
              <Box
                sx={{
                  height: "100%",
                  width: `${actualPct}%`,
                  bgcolor: x.actual > x.target ? chartPalette.amber : chartPalette.green,
                  borderRadius: 1,
                }}
              />
              <Box
                sx={{
                  position: "absolute",
                  left: `${targetPct}%`,
                  top: -3,
                  width: 3,
                  height: 24,
                  bgcolor: chartPalette.red,
                }}
              />
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}